import React from "react";

import gilroyRegular from "../fonts/gilroy-regular.woff2";
import gilroyRegularItalic from "../fonts/gilroy-regularitalic.woff2";
import gilroySemibold from "../fonts/gilroy-semibold.woff2";
import gilroyBold from "../fonts/gilroy-bold.woff2";

export default function GlobalStyles(props) {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `




@font-face {
    font-family: Gilroy;
    font-display: swap;
    font-weight: 400;
    font-style: normal;
    src: url(${gilroyRegular}) format("woff2");
}

@font-face {
    font-family: Gilroy;
    font-display: swap;
    font-weight: 400;
    font-style: italic;
    src: url(${gilroyRegularItalic}) format("woff2");
}


@font-face {
    font-family: Gilroy;
    font-display: swap;
    font-weight: 600;
    font-style: normal;
    src: url(${gilroySemibold}) format("woff2");
}



@font-face {
    font-family: Gilroy;
    font-display: swap;
    font-weight: 700;
    font-style: normal;
    src: url(${gilroyBold}) format("woff2");
}

* {
    box-model:border-box;
}

button, input {
    font-family: inherit;
}
    
button:hover {
    opacity: .8;
    cursor: pointer;
}



    `,
      }}
    />
  );
}
